export var KEY_UP = 'ArrowUp';
export var KEY_DOWN = 'ArrowDown';
export var KEY_SPACE = ' ';
export var KEY_ENTER = 'Enter';
export var KEY_TAB = 'Tab';
export var KEY_ESC = 'Escape';
//# sourceMappingURL=keys.js.map